import React, { Component } from 'react';
import MUIDataTable from 'mui-datatables';
import RolePermissionManagementService from '@services/RolePermissionManagementService';
import CSVGenerator from '@components/CSVGenerator';
import SupportAlert from '@components/SupportAlert';
import UpdateRoleDialog from '../../components/RolesManagement/UpdateRoleDialog';
import RolePermissionsDialog from '../../components/RolesManagement/RolePermissionsDialog';
import { CustomDialog } from 'react-st-modal';
import SpinnerModal from '@components/SpinnerModal';
import { Alert, Chip, FormControl, FormControlLabel, Grid, Stack, Switch } from '@mui/material';
import styles from './rolesmanagement.module.css';

class RolesManagement extends Component {
    state = {
        loading: false,
        viewSystemRoles: false,
        updateSystemRoles: false,
        systemRoles: [],
        allOrganisationStatuses: [],
    }

    parseJwt(token) {
        const base64Payload = token.split('.')[1];
        const payload = atob(base64Payload);
        return JSON.parse(payload.toString());
    }

    async componentDidMount() {
        this.setState({ loading: true });

        let payload = this.parseJwt(localStorage.getItem('Bearer'));
        this.setState({ surveysUserId: payload.user_id });

        const viewSystemRoles = await RolePermissionManagementService.userRolesCanActionResource(
            ['ADMINISTRATOR', 'PROJECT MANAGER', 'FIELDWORK MANAGER'],
            'VIEW',
            'SYSTEM_ROLES'
        );
        this.setState({ viewSystemRoles: viewSystemRoles });

        const updateSystemRoles = await RolePermissionManagementService.userRolesCanActionResource(
            ['ADMINISTRATOR', 'PROJECT MANAGER', 'FIELDWORK MANAGER'],
            'UPDATE',
            'SYSTEM_ROLES'
        );
        this.setState({ updateSystemRoles: updateSystemRoles });

        this.reloadSystemRoles();

        this.setState({ loading: false });
    }

    async reloadSystemRoles() {
        this.setState({ loading: true });

        await (async () => {
            try {
                const systemRolesAll = await RolePermissionManagementService.getRdiSystemRoles();
                this.setState({ systemRoles: JSON.parse(JSON.stringify(systemRolesAll)) });
                return systemRolesAll;
            } catch (ex) {
                console.log('Network error loading system roles');
            }
        })([]);

        this.setState({ loading: false });
    }

    async onUpdateRole(evt, updatedRoleEnvelope) {

        const finalResult = await (async () => {
            const result = await RolePermissionManagementService.saveRole(updatedRoleEnvelope);
            return result;
        })([]);

        await (async () => {
            if (finalResult !== 'Success') {
                return await SupportAlert.displayAlert('Role not updated. ', 'Update Role - Failed');
            } else {
                await this.reloadSystemRoles();
            }
        })([]);

        this.setState({ loading: false });
    }

    async handleViewRolePermissionsDialog(evt, rdiRole) {
        let title = 'System Role Permissions : ' + rdiRole.name;
        await CustomDialog(
            <RolePermissionsDialog
                {...this.props}
                backButton={{ text: 'Close' }}
                systemRoles={this.state.systemRoles}
                role={rdiRole}
                surveysUserId={this.state.surveysUserId}
            />,
            {
                className: styles.editRolesDialog,
                title: title,
                showCloseIcon: false,
                isFocusLock: true,
                isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
            }
        );
    }

    async handleUpdateRoleDialog(evt, rdiRole) {
        let title = 'Update System Role ';
        await CustomDialog(
            <UpdateRoleDialog
                {...this.props}
                backButton={{ text: 'Cancel' }}
                nextButton={{ text: 'Update', onClick: (evt, data) => this.onUpdateRole(evt, data) }}
                systemRoles={this.state.systemRoles}
                role={rdiRole}
                surveysUserId={this.state.surveysUserId}
            />,
            {
                className: styles.editRolesDialog,
                title: title,
                showCloseIcon: false,
                isFocusLock: true,
                isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
            }
        );
    }

    async handleFlipRoleActive(evt, setEnabled, roleId) {
        let systemRoles = this.state.systemRoles;

        systemRoles.filter((systemRole) => systemRole.id === roleId)[0].active = setEnabled;
        this.setState({
            systemRole: systemRoles
        });

        let updatedRoleEnvelope = {
            actionById: this.state.surveysUserId,
            rdiRole: this.state.systemRoles.filter((systemRole) => systemRole.id === roleId)[0]
        };

        this.onUpdateRole(evt, updatedRoleEnvelope)

    }

    systemRolesTable() {
        let tableTitle = 'Manage System Roles'.toUpperCase();

        let systemRolesTableData = [];

        let systemRolesColumns = [
            {
                label: "Role ID", name: "roleId"
                , options: {
                    // display: true,
                    display: false,
                }
            },
            { label: "Role name", name: "roleName" },
            { label: "Description", name: "description" },
            { label: "Role status", name: "active" },
            { label: "Role Actions", name: "actionButtons" },
        ];

        if (this.state.systemRoles !== undefined && this.state.systemRoles !== null && this.state.systemRoles.length >= 0) {

            this.state.systemRoles.sort((a, b) => a.id > b.id ? 1 : -1).map((systemRole) => {
                let row = {
                    roleId: systemRole.id,
                    roleName: systemRole.name,
                    description: systemRole.description,
                    active: <div>
                        <FormControl>
                            <FormControlLabel
                                control={
                                    <Switch
                                        size='small'
                                        color='primary'
                                        sx={{ m: 1 }}
                                        disabled={!this.state.updateSystemRoles}
                                        checked={systemRole.active}
                                        onChange={(evt) => {
                                            this.handleFlipRoleActive(evt, !systemRole.active, systemRole.id)
                                        }}
                                    />
                                }
                                label={systemRole.active ? "Active" : "Disabled"}
                            />
                        </FormControl>
                    </div>,
                    actionButtons: <div>
                        <Stack direction="column" spacing={0.5}>
                            <Chip
                                variant='outlined'
                                label='Update Role'
                                disabled={!this.state.updateSystemRoles}
                                onClick={evt => this.handleUpdateRoleDialog(evt, systemRole)} />
                            <Chip 
                                variant='outlined'
                                label='Manage Permissions'
                                onClick={evt => {
                                    this.handleViewRolePermissionsDialog(evt, systemRole);
                                }} />
                        </Stack>
                    </div>
                }

                systemRolesTableData.push(row);
                return null;
            });
        }

        let options = {
            padding: 'none',
            size: 'small',
            rowsPerPage: 10,
            rowsPerPageOptions: [10, 25, 100],
            jumpToPage: true,
            selectableRowsHideCheckboxes: true,
            textLabels: {
                toolbar: {
                    downloadCsv: "Export to excel",
                }
            },
            onDownload: (buildHead, buildBody, columns, data) => {
                (async () => {
                    await CSVGenerator.exportTableToXLS({
                        fileName: tableTitle,
                        columnNames: columns.filter(column => column.display !== 'false').map(item => item.label),
                        fileData: data.map(row => {
                            row.data.shift();
                            return row.data;
                        })
                    })
                })([]);
                return false;
            },
        };

        return <div className={styles.flex_row_container}>
            <MUIDataTable
                title={<div className={styles.featuredItem}><h1 className={styles.featuredTitleHeader}>{tableTitle}</h1></div>}
                data={systemRolesTableData}
                columns={systemRolesColumns}
                options={options}
            />
        </div>
    }

    render() {

        if (this.state.loading === true) {
            return <SpinnerModal settings={true} label={'Page loading ...'} />
        } else {
            return (
                <div className={styles.container_roles} >
                    {!this.state.viewSystemRoles
                        ? <div className={styles.featuredItem}>
                            <span className={styles.featuredTitleHeader}><h2>{'Roles Management'}</h2></span>
                            <hr />
                            <Grid container item xs={15} >
                                <Alert variant="outlined" severity="warning">{'Your current role and permissions does not allow role management functions. Please contact your supervisor or system administrator.'}</Alert>
                            </Grid>
                        </div>
                        : <div>
                            <div className={styles.featuredItem}>
                                <span className={styles.featuredTitleHeader}><h2>{'Roles Management'}</h2></span>
                                <hr />
                                <Grid container item xs={15} >
                                    
                                </Grid>
                            </div>
                            <div className={styles.featuredItem}>
                                <Grid container item xs={15} >
                                    {this.systemRolesTable()}
                                </Grid>
                            </div>
                        </div>
                    }
                </div>
            )
        }
    }
}
export default RolesManagement;